import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { updateParkingServiceOperationHours } from '../../api/parking-service.ts';
import { UpdateParkingServiceOperationHoursRequest } from '../../api/requests/parking-service-request.ts';

export default function useUpdateParkingServiceOperationHours(): UseMutationResult<
  Awaited<ReturnType<typeof updateParkingServiceOperationHours>>,
  Error,
  UpdateParkingServiceOperationHoursRequest
> {
  return useMutation({
    mutationFn: updateParkingServiceOperationHours,
  });
}
